export default __webpack_public_path__ + "static/media/chani calm.c03352a0.svg";